<!--
 * @Description: 
 * @Author: 朱海良
 * @Date: 2022-08-23 18:26:16
 * @LastEditors: 朱海良 421973703@qq.com
 * @LastEditTime: 2023-10-31 11:14:11
-->
<template>
  <div class="head">
    <div class="logo"></div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Head extends Vue {}
</script>
<style scoped lang="less">
@media screen and (max-width: 600px) {
  .head {
    display: none;
  }
}
.head {
  width: 100%;
  height: 280px;
  background: url("../../public/img/banner@2x.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .logo {
    width: 197px;
    height: 113px;
    background: url("../../public/img/logox.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 127px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
